/* eslint-disable @typescript-eslint/no-namespace */ /* eslint-disable @typescript-eslint/no-use-before-define */ /* eslint-disable @typescript-eslint/prefer-namespace-keyword */ /* eslint-disable @typescript-eslint/no-inferrable-types */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Constants } from './constants';
import { getCookieOptionExpires } from './cookieUtils';
import { getWindow, getDocument } from './../services/window';
import { isNullorUndefined } from './objectUtils';
import { isEmptyNullorUndefinedString } from './stringUtils';
import { stringifyError } from './errorUtils';
import { logger } from '@src/logger';
// NOTE:
//  DO NOT access directly to, or from browser, for following items
//      1) cookie data, or
//      2) local storage data
//
//  instead, please use methods in this util to access
//  e.g.
//      get cookie data
//          1) BrowserStorage.getBrowserStorage().getCookieItem(...)
//          2) getCookieItem(...)
//      set cookie data
//          1) BrowserStorage.getBrowserStorage().setCookieItem(...)
//          2) saveCookieItem(...)
//      get local storage data
//          1) BrowserStorage.getBrowserStorage().getLocalStorageItem(...)
//          2) getLocalStorageItem(...)
//      set local storage data
//          1) BrowserStorage.getBrowserStorage().setLocalStorageItem(...)
//          2) saveLocalStorageItem(...)
//
// shortcut methods below are for ease of access
export function hasUserAgreedPrivacyConsent() {
    return BrowserStorage.getBrowserStorage().hasUserAgreedPrivacyConsent();
}
export function saveDataToBrowserAfterUserAgreedPrivacyConsent() {
    BrowserStorage.getBrowserStorage().saveDataToBrowserAfterUserAgreedPrivacyConsent();
}
export function saveCookieItem(itemName, itemValue, optionText = getCookieOptionExpires()) {
    BrowserStorage.getBrowserStorage().setCookieItem(itemName, itemValue, optionText);
}
export function getCookieItem(itemName, shouldDecode = true) {
    return BrowserStorage.getBrowserStorage().getCookieItem(itemName, shouldDecode);
}
export function saveLocalStorageItem(itemName, itemValue) {
    BrowserStorage.getBrowserStorage().setLocalStorageItem(itemName, itemValue);
}
export function getLocalStorageItem(itemName) {
    return BrowserStorage.getBrowserStorage().getLocalStorageItem(itemName);
}
export function saveSessionStorageItem(itemName, itemValue) {
    BrowserStorage.getBrowserStorage().setSessionStorageItem(itemName, itemValue);
}
export function getSessionStorageItem(itemName) {
    return BrowserStorage.getBrowserStorage().getSessionStorageItem(itemName);
}
(function(BrowserStorage) {
    // singleton
    // eslint-disable-next-line no-undef-init
    let browserStorage = undefined;
    function getBrowserStorage() {
        if (!browserStorage) {
            browserStorage = new BrowserStorage1();
        }
        return browserStorage;
    }
    BrowserStorage.getBrowserStorage = getBrowserStorage;
    // DO NOT export class
    class BrowserStorage1 {
        getDefaultBrowserStorageData() {
            const browserStorageData = {
                localStorage: {},
                cookies: {}
            };
            return browserStorageData;
        }
        // since we have a flushStore method, store may be undefined when called after privacy consent expired, or
        getStore() {
            if (!this.store) {
                this.store = this.getDefaultBrowserStorageData();
            }
            return this.store;
        }
        /**
     * get cookie item value
     *
     *  get cookie item value
     *      1) directly from browser, if user accepted privacy consent, and privacy consent has not expired, or
     *      2) from store buffer, if user hasn't accepted privacy consent, or privacy consent has expired
     *
     * @param itemName cookie item name
     * @param shouldDecode cookie should be decoded
     *
     * @returns value of cookie item, as primitive or an object
     */ getCookieItem(itemName, shouldDecode = true) {
            if (this.hasUserAgreedPrivacyConsent() || Constants.Cookies.Essential[`${itemName}`]) {
                return cookieUtils.getCookieItemFromBrowser(itemName, shouldDecode);
            }
            return this.getStore().cookies[`${itemName}`];
        }
        /**
     * set cookie item value
     *
     *  set cookie item value
     *      1) directly to browser, if user accepted privacy consent, and privacy consent has not expired, or
     *      2) to store buffer, if user hasn't accepted privacy consent, or privacy consent has expired
     *
     * @param itemName cookie item name
     * @param itemName cookie item value
     * @param optionText cookie options as a string
     */ setCookieItem(itemName, itemValue, optionText = getCookieOptionExpires()) {
            if (this.hasUserAgreedPrivacyConsent() || Constants.Cookies.Essential[`${itemName}`]) {
                cookieUtils.setCookieItemToBrowser(itemName, itemValue, optionText);
                return;
            }
            const cookieData = this.getStore().cookies;
            cookieData[`${itemName}`] = itemValue;
        }
        /**
     * get local storage item value
     *
     *  get local storage item value
     *      1) directly from browser, if user accepted privacy consent, and privacy consent has not expired, or
     *      2) from store buffer, if user hasn't accepted privacy consent, or privacy consent has expired
     *
     * @param itemName local storage item name
     *
     * @returns value of local storage item, as primitive or an object
     */ getLocalStorageItem(itemName) {
            const userAgreedPrivacyConsent = this.hasUserAgreedPrivacyConsent();
            logger.info(JSON.stringify({
                userAgreedPrivacyConsent,
                itemName
            }), {
                action: Constants.Telemetry.Action.LocalStorage,
                actionModifier: Constants.Telemetry.ActionModifier.GetItem
            });
            if (userAgreedPrivacyConsent || Constants.LocalStorage.Essentials.includes(itemName)) {
                return localStorageUtils.getLocalStorageItemFromBrowser(itemName);
            }
            return this.getStore().localStorage[`${itemName}`];
        }
        getSessionStorageItem(itemName) {
            if (this.hasUserAgreedPrivacyConsent()) {
                return localStorageUtils.getSessionStorageItemFromBrowser(itemName);
            }
            return this.getStore().localStorage[`${itemName}`];
        }
        /**
     * set local storage item value
     *
     *  set local storage item value
     *      1) directly to browser, if user accepted privacy consent, and privacy consent has not expired, or
     *      2) to store buffer, if user hasn't accepted privacy consent, or privacy consent has expired
     *
     * @param itemName local storage item name
     * @param itemValue local storage item value
     */ setLocalStorageItem(itemName, itemValue) {
            const userAgreedPrivacyConsent = this.hasUserAgreedPrivacyConsent();
            logger.info(JSON.stringify({
                userAgreedPrivacyConsent,
                itemName
            }), {
                action: Constants.Telemetry.Action.LocalStorage,
                actionModifier: Constants.Telemetry.ActionModifier.SaveItem
            });
            if (userAgreedPrivacyConsent || Constants.LocalStorage.Essentials.includes(itemName)) {
                localStorageUtils.setLocalStorageItemToBrowser(itemName, itemValue);
                return;
            }
            const localStorageData = this.getStore().localStorage;
            localStorageData[`${itemName}`] = itemValue;
        }
        setSessionStorageItem(itemName, itemValue) {
            if (this.hasUserAgreedPrivacyConsent()) {
                localStorageUtils.setSessionStorageItemToBrowser(itemName, itemValue);
                return;
            }
            const sessionStorageData = this.getStore().localStorage;
            sessionStorageData[`${itemName}`] = itemValue;
        }
        /**
     * save browser storage buffer data to browser, then flush buffer
     */ saveDataToBrowserAfterUserAgreedPrivacyConsent() {
            if (!this.hasUserAgreedPrivacyConsent()) {
                // indicate user has agreed our privacy consent
                this.setUserHasAgreedPrivacyConsent();
            }
            // dump and flush
            this.dumpAndFlushStore();
        }
        /**
     * save browser storage buffer data to browser, then flush buffer
     */ dumpAndFlushStore() {
            // dump
            this.copyStoreToBrowser();
            // flush
            this.flushStore();
        }
        /**
     * copy browser storage buffer data to brower storage, i.e. cookie, and local storage
     */ copyStoreToBrowser() {
            // dump cookie
            this.copyStoreCookiesToBrowser();
            // dump local storage
            this.copyStoreLocalStorageToBrowser();
        }
        /**
     * copy browser storage cookie buffer data to brower storage cookie
     */ copyStoreCookiesToBrowser() {
            try {
                const cookieData = this.getStore().cookies;
                Object.keys(cookieData).forEach((cookieName)=>{
                    const cookieValue = cookieData[`${cookieName}`];
                    if (isEmptyNullorUndefinedString(cookieValue)) {
                        return;
                    }
                    this.setCookieItem(cookieName, cookieValue);
                });
            } catch (error) {
                const errorText = isNullorUndefined(error) ? undefined : stringifyError(error);
                const errorMessage = `Failed: Dump browser storage cookie buffer data to browser storage cookie, Error: ${errorText}`;
                BrowserStorage.TelemetryUtils.logTelemetryForAccessError(Constants.Telemetry.Action.Copy, Constants.Telemetry.ActionModifier.BrowserStorageCookieDataBuffer, errorMessage);
            }
        }
        /**
     * copy browser storage local storage buffer data to brower storage local storage
     */ copyStoreLocalStorageToBrowser() {
            try {
                const localStorageData = this.getStore().localStorage;
                Object.keys(localStorageData).forEach((localStorageItemName)=>{
                    const localStorageItemValue = localStorageData[`${localStorageItemName}`];
                    if (isEmptyNullorUndefinedString(localStorageItemValue)) {
                        return;
                    }
                    this.setLocalStorageItem(localStorageItemName, localStorageItemValue);
                });
            } catch (error) {
                const errorText = isNullorUndefined(error) ? undefined : stringifyError(error);
                const errorMessage = `Failed: Dump browser storage local storage buffer data to brower storage local storage, Error: ${errorText}`;
                BrowserStorage.TelemetryUtils.logTelemetryForAccessError(Constants.Telemetry.Action.Copy, Constants.Telemetry.ActionModifier.BrowserStorageLocalStorageDataBuffer, errorMessage);
            }
        }
        // flush browser storage buffer data
        flushStore() {
            this.store = this.getDefaultBrowserStorageData();
        }
        hasUserAgreedPrivacyConsent() {
            return cookieUtils.isValidForUserAgreedPrivacyConsent();
        }
        setUserHasAgreedPrivacyConsent() {
            cookieUtils.setUserHasAgreedPrivacyConsent();
        }
        constructor(store){
            // browser storage buffer consists of local storage data and cookie data
            _define_property(this, "store", void 0);
            this.store = store;
            if (!this.store) {
                this.store = this.getDefaultBrowserStorageData();
            }
        }
    }
    // NOTE: This module should only be used in class BrowserStorage
    // DO NOT export module
    (function(cookieUtils) {
        function getCookieItemFromBrowser(itemName, shouldDecode = true) {
            try {
                const cookiePrefix = `${itemName}=`;
                const cookieArray = getDocument().cookie.split(';').map((cookie)=>cookie.trim());
                // eslint-disable-next-line no-undef-init
                let cookieValue = undefined;
                // find the cookie
                // break the loop immediately once found
                cookieArray.some((cookie)=>{
                    if (cookie.indexOf(cookiePrefix) === 0) {
                        const rawValue = cookie.substring(cookiePrefix.length);
                        cookieValue = shouldDecode ? JSON.parse(decodeURIComponent(rawValue)) : rawValue;
                        return true;
                    }
                    return false;
                });
                return cookieValue;
            } catch (error) {
                const errorText = isNullorUndefined(error) ? undefined : stringifyError(error);
                const errorMessage = `Failed: read access of cookie item ${itemName} shouldDecode ${shouldDecode}, Error: ${errorText}`;
                BrowserStorage.TelemetryUtils.logTelemetryForAccessError(Constants.Telemetry.Action.ReadAccess, Constants.Telemetry.ActionModifier.CookieItem, errorMessage);
                return undefined;
            }
        }
        /**
     * read cookie directly from browser
     *
     *  NOTE: this method should not be directly called elsewhere but only in class BrowserStorage
     *
     * @param itemName cookie item name
     * @param shouldDecode cookie should be decoded
     *
     * @returns value of cookie item, as primitive or an object
     */ cookieUtils.getCookieItemFromBrowser = getCookieItemFromBrowser;
        function setCookieItemToBrowser(itemName, itemValue, optionText = getCookieOptionExpires()) {
            try {
                getDocument().cookie = `${itemName}=${itemValue};path=/;${optionText}`;
            } catch (error) {
                const errorText = isNullorUndefined(error) ? undefined : stringifyError(error);
                const errorMessage = `Failed: write access of cookie item ${itemName} value ${itemValue}, Error: ${errorText}`;
                BrowserStorage.TelemetryUtils.logTelemetryForAccessError(Constants.Telemetry.Action.WriteAccess, Constants.Telemetry.ActionModifier.CookieItem, errorMessage);
                return errorMessage;
            }
        }
        /**
     * save cookie directly to browser
     *
     *  NOTE: this method should not be directly called elsewhere but only in class BrowserStorage
     *
     * @param itemName cookie item name
     * @param itemValue cookie item value
     * @param optionText cookie options as a string
     */ cookieUtils.setCookieItemToBrowser = setCookieItemToBrowser;
        function isValidForUserAgreedPrivacyConsent() {
            const cookie = getCookieItemFromBrowser(Constants.Cookies.privacyConsentAcceptedDate, false);
            return !isCookieExpired(cookie);
        }
        /**
     * check whether user has agreed privacy consent, which should also be valid
     *
     *  NOTE: this method is an exception which directly access the browser storage
     *
     * @returns true if all following apllies:
     *      1) user has agreed to privacy consent
     *      2) agreed privacy consent has not expired
     */ cookieUtils.isValidForUserAgreedPrivacyConsent = isValidForUserAgreedPrivacyConsent;
        /**
     * Check if user accepted privacy consent is expired.
     *
     *  NOTE: currently is only capable of checking if cookie value consists only of a time string
     *  TO DO: update to check other cookie expiry, whose cookie value has a substring of `;path=\;${expiry}`
     *
     *  @param cookieValue: cookie item value
     *  @param expiry: valid duration, default is 13 months after saved in browser
     *
     *  @returns
     *      true, if cookie is empty, or has no expiration date, or expired
     *      false, otherwise
     */ function isCookieExpired(cookieValue, expiry = Constants.CookieExpiry.Default) {
            if (!cookieValue) {
                return true;
            }
            const date = new Date();
            const currentTime = date.getTime();
            const cookieInitialTime = parseInt(cookieValue, 10);
            const cookieEndTime = cookieInitialTime + expiry;
            return currentTime > cookieEndTime;
        }
        function setUserHasAgreedPrivacyConsent() {
            setCookieItemToBrowserForUserAgreedPrivacyConsentDate();
        }
        /**
     * set a flag indicating user has agreed to privacy consent, banner at the top
     *
     *  this is achieved by simply setting a privacy consent accepted date as a cookie in browser
     *  NOTE: this method is an exception which directly access the browser storage
     */ cookieUtils.setUserHasAgreedPrivacyConsent = setUserHasAgreedPrivacyConsent;
        /**
     * save expiration date of privacy consent cookie (banner at the top)
     *
     *  cookie banner won't show to user for next 13 months.
     *  NOTE: this method is an exception which directly access the browser storage
     */ function setCookieItemToBrowserForUserAgreedPrivacyConsentDate() {
            // skip if user-agreed privacy consent is valid
            if (isValidForUserAgreedPrivacyConsent()) {
                return;
            }
            // update cookie accepted date to current
            const cookieAcceptedDate = Date.now().toString();
            // a cookie serves as
            //  a) a value when checking expiry, also serves as
            //  b) a flag indicating user has agreed privacy consent
            setCookieItemToBrowser(Constants.Cookies.privacyConsentAcceptedDate, cookieAcceptedDate);
        }
    })(cookieUtils || (cookieUtils = {}));
    // NOTE: This module should only be used in class BrowserStorage
    // DO NOT export module
    (function(localStorageUtils) {
        function getLocalStorageItemFromBrowser(itemName) {
            try {
                const localStorage = getWindow().localStorage;
                return localStorage.getItem(itemName);
            } catch (error) {
                const errorText = isNullorUndefined(error) ? undefined : stringifyError(error);
                const errorMessage = `Failed: read access of local storage item ${itemName}, Error: ${errorText}`;
                BrowserStorage.TelemetryUtils.logTelemetryForAccessError(Constants.Telemetry.Action.ReadAccess, Constants.Telemetry.ActionModifier.LocalStorageItem, errorMessage);
                return errorMessage;
            }
        }
        /**
     * read local storage item directly from browser
     *
     *  NOTE: this method should not be directly called elsewhere but only in class BrowserStorage
     *
     * @param itemName local storage item name
     *
     * @returns local storage item value, as primitive or an object
     */ localStorageUtils.getLocalStorageItemFromBrowser = getLocalStorageItemFromBrowser;
        function getSessionStorageItemFromBrowser(itemName) {
            try {
                const sessionStorage = getWindow().sessionStorage;
                return sessionStorage.getItem(itemName);
            } catch (error) {
                const errorText = isNullorUndefined(error) ? undefined : stringifyError(error);
                const errorMessage = `Failed: read access of session storage item ${itemName}, Error: ${errorText}`;
                BrowserStorage.TelemetryUtils.logTelemetryForAccessError(Constants.Telemetry.Action.ReadAccess, Constants.Telemetry.ActionModifier.SessionStorageItem, errorMessage);
                throw errorMessage;
            }
        }
        localStorageUtils.getSessionStorageItemFromBrowser = getSessionStorageItemFromBrowser;
        function setLocalStorageItemToBrowser(itemName, itemValue) {
            try {
                const localStorage = getWindow().localStorage;
                localStorage.setItem(itemName, itemValue);
            } catch (error) {
                const errorText = isNullorUndefined(error) ? undefined : stringifyError(error);
                const errorMessage = `Failed: write access of local storage item ${itemName} value ${itemValue}, Error: ${errorText}`;
                BrowserStorage.TelemetryUtils.logTelemetryForAccessError(Constants.Telemetry.Action.WriteAccess, Constants.Telemetry.ActionModifier.LocalStorageItem, errorMessage);
                return errorMessage;
            }
        }
        /**
     * save local storage directly to browser
     *
     *  NOTE: this method should not be directly called elsewhere but only in class BrowserStorage
     *
     * @param itemName local storage item name
     * @param itemValue local storage item value
     */ localStorageUtils.setLocalStorageItemToBrowser = setLocalStorageItemToBrowser;
        function setSessionStorageItemToBrowser(itemName, itemValue) {
            try {
                const sessionStorage = getWindow().sessionStorage;
                sessionStorage.setItem(itemName, itemValue);
            } catch (error) {
                const errorText = isNullorUndefined(error) ? undefined : stringifyError(error);
                const errorMessage = `Failed: write access of session storage item ${itemName} value ${itemValue}, Error: ${errorText}`;
                BrowserStorage.TelemetryUtils.logTelemetryForAccessError(Constants.Telemetry.Action.WriteAccess, Constants.Telemetry.ActionModifier.SessionStorageItem, errorMessage);
                throw errorMessage;
            }
        }
        localStorageUtils.setSessionStorageItemToBrowser = setSessionStorageItemToBrowser;
    })(localStorageUtils || (localStorageUtils = {}));
    (function(TelemetryUtils) {
        function logTelemetryForAccessError(action, actionModifier, errorMessage = undefined) {
            const page = getWindow() && getWindow().location && getWindow().location.href;
            const payload = {
                page: page,
                action: action,
                actionModifier: actionModifier,
                details: errorMessage
            };
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
        }
        /**
     * log telemetry read, or write access error on browser storage, cookie, and local storage
     *
     * @param action telemetry action
     * @param actionModifier telemetry action modifier
     * @param errorMessage telemetry details message
     */ TelemetryUtils.logTelemetryForAccessError = logTelemetryForAccessError;
    })(BrowserStorage.TelemetryUtils || (BrowserStorage.TelemetryUtils = {}));
    var cookieUtils, localStorageUtils;
})(BrowserStorage || (BrowserStorage = {}));
export var BrowserStorage;
